export const objectOrNull = ( v ) => {
	if ( v === null ) {
		return true;
	}

	return ( typeof v === 'object' && !Array.isArray( v ) );
};

export default {
	objectOrNull,
};
